import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import {
  IonAvatar,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonRouterOutlet,
  IonSplitPane,
  IonToolbar,
  IonTitle,
} from '@ionic/angular/standalone';

import { addIcons } from 'ionicons';
import { eyeOffOutline } from 'ionicons/icons';

import { MainMenuComponent } from '../../components/menus/main-menu/main-menu.component';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-default-layout',
  standalone: true,
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  imports: [
    IonAvatar,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonMenu,
    IonRouterOutlet,
    IonSplitPane,
    IonToolbar,
    IonTitle,
    MainMenuComponent,
    AsyncPipe,
  ]
})
export class DefaultLayoutComponent {

  // Current signed-in user.
  readonly user$ = this.auth.user$;

  // Current impersonation state.
  readonly impersonation$ = this.auth.impersonation$;

  // Whether the impersonation side panel is open.
  impTabOpen = false;
  impTabY: number | null = null;
  private impTabDrag: { pointerId: number; startY: number; centerY: number } | null = null;
  private impTabDragged = false;

  // Whether the current page wants the global main menu hidden.
  hideMainMenu = false;

  // Optional extra layout mode for special pages.
  layoutMode: string | null = null;

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {
    addIcons({
      eyeOffOutline
    });

    // Listen for the final activated route in the primary outlet.
    this.router.events.pipe(
      filter((event): event is ActivationEnd => event instanceof ActivationEnd),
      filter((event) => event.snapshot.outlet === 'primary'),
      filter((event) => !event.snapshot.firstChild),
    ).subscribe((event) => {
      const data = event.snapshot.data || {};

      console.log('Active route data:', data); // temp debug

      this.hideMainMenu = !!data['hideMainMenu'];
      this.layoutMode = data['layoutMode'] ?? null;
    });
  }

  // Toggle the impersonation side panel.
  toggleImpTab(event?: MouseEvent): void {
    if (event?.detail && this.impTabDragged) return;
    this.impTabOpen = !this.impTabOpen;
  }

  startImpTabDrag(event: PointerEvent): void {
    if (!event.isPrimary || event.button !== 0) return;
    const toggle = event.currentTarget as HTMLElement;
    const bounds = toggle.getBoundingClientRect();
    this.impTabDragged = false;
    this.impTabDrag = {
      pointerId: event.pointerId,
      startY: event.clientY,
      centerY: bounds.top + bounds.height / 2,
    };
    toggle.setPointerCapture(event.pointerId);
  }

  moveImpTabDrag(event: PointerEvent): void {
    const drag = this.impTabDrag;
    if (!drag || drag.pointerId !== event.pointerId) return;
    const delta = event.clientY - drag.startY;
    if (!this.impTabDragged && Math.abs(delta) < 6) return;
    this.impTabDragged = true;
    const margin = (event.currentTarget as HTMLElement).offsetHeight / 2 + 12;
    this.impTabY = Math.max(margin, Math.min(window.innerHeight - margin, drag.centerY + delta));
  }

  endImpTabDrag(event: PointerEvent): void {
    if (this.impTabDrag?.pointerId !== event.pointerId) return;
    this.impTabDrag = null;
    const toggle = event.currentTarget as HTMLElement;
    if (toggle.hasPointerCapture(event.pointerId)) toggle.releasePointerCapture(event.pointerId);
  }

  // Force close the impersonation side panel.
  closeImpTab(): void {
    this.impTabOpen = false;
  }

}
